import { render, staticRenderFns } from "./escalated-alert-card-tabs.vue?vue&type=template&id=c0cd691e&"
import script from "./escalated-alert-card-tabs.vue?vue&type=script&lang=ts&"
export * from "./escalated-alert-card-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./escalated-alert-card-tabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports